import React, { useState } from "react";
import { Table, Tooltip } from "reactstrap";

const StatsTableComponent = ({ columns, data, keyMap, renderActions }) => {
  const [tooltipOpen, setTooltipOpen] = useState({});

  const toggleTooltip = (id) => {
    setTooltipOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  return (
    <Table className="align-items-center table-flush mt-3" responsive>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              scope="col"
              key={index}
              className="custom-table-heading custom-heading "
            >
              {column}
            </th>
          ))}
          {renderActions && (
            <th scope="col" className="custom-table-heading custom-heading">
              Action
            </th>
          )}
        </tr>
      </thead>
      <tbody className="custom-table-body mt-3">
        {data?.length > 0 ? (
          data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.keys(keyMap).map((key, colIndex) => {
                const cellId = `tooltip-${rowIndex}-${colIndex}`;
                const cellText = row[key] || "N/A";
                return (
                  <td
                    key={colIndex}
                    className="custom-table-text truncated-text"
                    id={cellId}
                  >
                    {cellText.length > 30
                      ? `${cellText.slice(0, 30)}...`
                      : cellText}
                    {cellText.length > 30 && (
                      <Tooltip
                        placement="top"
                        isOpen={tooltipOpen[cellId] || false}
                        target={cellId}
                        toggle={() => toggleTooltip(cellId)}
                      >
                        {cellText}
                      </Tooltip>
                    )}
                  </td>
                );
              })}
              {renderActions && (
                <td className="card-subtitle">{renderActions(row)}</td>
              )}
            </tr>
          ))
        ) : (
          <tr>
            {Object.keys(keyMap).map((_, colIndex) => (
              <td key={colIndex} className="custom-table-text">
                N/A
              </td>
            ))}
            {renderActions && <td className="card-subtitle">N/A</td>}
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default StatsTableComponent;
